import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { publicStockApi } from '@/lib/api/public-stock.api';

export const usePublicStockCar = (id: string | undefined) =>
  useQuery({
    queryKey: ['public-stock-car', id],
    queryFn: () => publicStockApi.getCar(id as string),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    // 404 (sold / unknown) and 429 (rate limited) will not change on a quick retry.
    retry: (failureCount, error) => {
      const status = axios.isAxiosError(error) ? error.response?.status : undefined;
      if (status === 404 || status === 429) return false;
      return failureCount < 1;
    },
  });
